import * as UserApi from "Data/users/UserApi";
import UserConstants from "Data/users/UserConstants";

import { successNotification, failureNotification } from "Data/notifications/NotificationActions";

const receivedUser = (invite) => ({
    type: UserConstants.USER_RECEIVED,
    payload: {
        id: invite.id,
        account_id: invite.account_id,
        name: invite.name,
        email: invite.email,
        created_at: invite.created_at,
        updated_at: invite.updated_at,
    }
});

const receivedInvite = (invite) => ({
    type: UserConstants.INVITE_RECEIVED,
    payload: {
        id: invite.id,
        account_id: invite.account_id,
        email: invite.email,
        created_at: invite.created_at,
        updated_at: invite.updated_at,
    }
});

const revokedInvite = (id) => ({
    type: UserConstants.INVITE_REVOKED,
    payload: {
        id: id,
    }
});

const removedTeamMember = (id) => ({
    type: UserConstants.TEAM_MEMBER_REMOVED,
    payload: {
        id: id,
    }
});


export function fetchInvite(token) {
    return function (dispatch, getState) {
        return UserApi.fetchInvite(token);
    };
}

export function fetchInvites() {
    return function (dispatch, getState) {
        const accountId = getState().currentAccountId;
        return UserApi.listInvites(accountId).then(response => {
            response.map(invite => {
                dispatch(receivedInvite(invite))
            });
        });
    };
}

export function fetchTeamMembers() {
    return function (dispatch, getState) {
        const accountId = getState().currentAccountId;
        return UserApi.listTeamMembers(accountId).then(response => {
            response.map(user => {
                dispatch(receivedUser(user))
            });
        });
    };
}

export function changePassword(current, changed) {
    return function (dispatch) {
        return UserApi.changePassword(current, changed)
            .then(() => {
                dispatch(successNotification('Password changed!'))
            })
            .catch(error => {
                dispatch(failureNotification('Error changing password! :('))
            });
    };
}

export function invite(email) {
    return function (dispatch, getState) {
        const accountId = getState().currentAccountId;

        return UserApi.invite(accountId, email)
            .then(() => {
                dispatch(fetchInvites());
                dispatch(successNotification('Invite sent!'))
            })
            .catch(error => {
                dispatch(failureNotification('Error sending invite.'))
            });
    }
}

export function revokeInvite(id) {
    return function (dispatch, getState) {
        return UserApi.revokeInvite(id)
            .then(() => {
                dispatch(revokedInvite(id));
                dispatch(successNotification('Invite revoked!'))
            })
            .catch(error => {
                dispatch(failureNotification('Error revoking invite.'))
            });
    }
}

export function acceptInvite(token, fullname, password) {
    return function (dispatch, getState) {
        return UserApi.acceptInvite(token, fullname, password)
            .then(() => {
                window.location = '/accounts';
            })
            .catch(error => {
                dispatch(failureNotification('Error accepting invite.'))
            });
    }
}

export function removeTeamMember(id) {
    return function (dispatch, getState) {
        const accountId = getState().currentAccountId;
        return UserApi.removeTeamMember(accountId, id)
            .then(() => {
                dispatch(removedTeamMember(id));
                dispatch(successNotification('Member removed!'))
            })
            .catch(error => {
                dispatch(failureNotification('Error removing member.'))
            });
    }
}